const initMondayClient = require('monday-sdk-js');

export async function changeColumnTitle(boardId, columnId, value) {
    try {
        const mondayClient = initMondayClient();
        // mondayClient.setToken(shortLivedToken);
        mondayClient.setApiVersion('2025-10');
        const query = `mutation{
            change_column_title(board_id: ${boardId},column_id: "${columnId}", title:"${value} Number") {
                id
            }
        }`;
        const response = await mondayClient.api(query);
        console.log('Resss ', response);
        return response;

    } catch (err) {
        console.error('Error ', err);
    }
}

export  async function getSubScription(){

    
	try {
		const mondayClient = initMondayClient();
		// mondayClient.setToken(shortLivedToken);
		mondayClient.setApiVersion(process.env.MONDAY_API_VERSION);
		const query = `query {
            me {
              is_guest
              created_at
              name
              id
              }
            app_subscription {
              plan_id
              is_trial
              billing_period
              days_left
            }
          }`;

		const response = await mondayClient.api(query);
		console.log('subscription data ',response);
		return response;

	} catch (err) {
		console.error(err);
		return 'error';
	}

}

export async function readColumnsQuery(boardId){
	try{
		const mondayClient = initMondayClient();
		// mondayClient.setToken(shortLivedToken);
		console.log(process.env.MONDAY_API_VERSION);
		mondayClient.setApiVersion(process.env.MONDAY_API_VERSION);
		const query=`query {
      boards (ids: ${boardId}) {
        columns {
          id
          title
        }		
      }
    }`;
		const response=await mondayClient.api(query);
		return response;
	}catch(err){
		console.error('Error ',err);
		return null;
	}
}

export async function createColumnQuery(boardId,title,type,id){
	try{
		const mondayClient = initMondayClient();
		// mondayClient.setToken(shortLivedToken);
		console.log(process.env.MONDAY_API_VERSION);
		mondayClient.setApiVersion(process.env.MONDAY_API_VERSION);
		const query=`mutation{
        create_column(board_id: ${boardId}, title:"${title}", column_type:${type},id:"${id}") {
            id
            title
            description
        }
        }`;
		const response=await mondayClient.api(query);
		return response;

	}catch(err){
		console.error('Error ',err);
		return null;
	}
}

export async function createStatusColumnQuery(boardId,title,type,id,statusColumnLabels){
	try{
		const mondayClient = initMondayClient();
		// mondayClient.setToken(shortLivedToken);
		console.log(process.env.MONDAY_API_VERSION);
		mondayClient.setApiVersion(process.env.MONDAY_API_VERSION);
		const query = `mutation ($board: ID!, $title: String!,$defaults: JSON!) { create_column(board_id: $board, title: $title, column_type:${type}, id:"${id}",defaults: $defaults){ id } }`;
		const variables = {
			board: boardId,
			title: `${title}`,
			defaults: JSON.stringify(statusColumnLabels),
		};
		const response=await mondayClient.api(query,{variables});
		return response;

	}catch(err){
		console.error('Error ',err);
		return null;
	}
}

export const mondayContextProcess = async () => {
  try {
    const mondayClient = initMondayClient();
    const contextResponse = await mondayClient.get('context');
    return contextResponse.data;
  } catch (err) {
    console.error('Error fetching Monday context:', err);
    return null;
  }
}